'use strict';/* global define:false */define('modules/core/modules/dashboard/services/updates-factory/index',[],function(){'use strict';/**
   * UpdatesFactory
   *
   * @tested
   */function factory($resource,API_ENDPOINT){var url=API_ENDPOINT+'update-stream';return $resource(url);}factory.$inject=['$resource','API_ENDPOINT'];return factory;});
